
/*
    API requests for Lane Changes and Lane Assignments,
    basic get methods, a create and an update
*/

import axios from "axios";
import BaseValues from "./BaseValues";

//
//
export const getLaneAssignents = (location) => {
    const data = BaseValues.createFormData({location});

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getLaneAssignments`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
//
export const getLaneChanges = (location) => {
    const data = BaseValues.createFormData({location: location});

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getGateReassignment`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
//
export const addLaneChange = (params) => {
    const data = BaseValues.createFormData(params);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/addGateReassignment`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
//
export const updateLaneChange = (params) => {
    const data = BaseValues.createFormData(params);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/updateGateReassignment`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
//
export const deleteLaneChange = (params) => {
    const data = BaseValues.createFormData(params);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/deleteGateReassignment`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}


/*

Boolean addGateReassignment(
		  string token  				//(usertoken/sso)
		  string location_id
		  string route
		  string current_gate
		  string new_gate
		  string start_date  			//date format : "DD-MON-YY HH:MI AM"
		  string end_date)    			//date format : "DD-MON-YY HH:MI AM"

      Boolean updateGateReassignment(
		  string token  				//(usertoken/sso)
		  string id						//(existing reassignment ID from getGateReassignments)
		  string location_id
		  string route
		  string current_gate
		  string new_gate	
		  string start_date				//date format : "DD-MON-YY HH:MI AM"
		  string end_date)				//date format : "DD-MON-YY HH:MI AM"
	  List<GateReassignment> getGateReassignments(
			string token) 				//(usertoken/sso)
			***************see GateReassignment retrrn below)
	  Boolean deleteGateReassignment(
		  string token  				//(usertoken/sso)
		  string id						//(existing reassignment ID from getGateReassignments)

	   GateReassignment object :
		  string location_id
		  string route
		  string current_gate
		  string new_gate
		  string start_date  			//date format : "DD-MON-YY HH:MI AM"
		  string end_date				//date format : "DD-MON-YY HH:MI AM"
		  string last_modified 			//date format : "DD-MON-YY HH:MI AM"
		  string username				//the user who created/edited last

*/